/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import { RadioInputInterface } from './radioInputTypes';
import style from './radioUnput.module.scss';
import { INPUT_GLOBAL_TYPES } from '../../constants/constants';
import '../../constants/_global.scss';

const RadioInput: React.FC<RadioInputInterface> = ({
  name,
  value,
  checked,
  onChange,
}) => {
  const [isChecked, setIschecked] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isValue, setIsValue] = useState<string>(value);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setIschecked(checked);
  }, [checked]);

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
      setIschecked(!isChecked);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className={style.shell}>
      <input
        type={INPUT_GLOBAL_TYPES.Radio}
        className={style.hiddenInput}
        ref={inputRef}
        checked={isChecked}
        name={name}
        value={isValue}
        onChange={handleChange}
      />
      <div
        className={isChecked ? style.inputActive : style.inputRegular}
        onClick={handleClick}
      />
      <label className="h2">{value}</label>
    </div>
  );
};

export default RadioInput;
